import { render } from "./Quality.vue?vue&type=template&id=f36cc5b6&scoped=true"
import script from "./Quality.vue?vue&type=script&lang=js"
export * from "./Quality.vue?vue&type=script&lang=js"

import "./Quality.vue?vue&type=style&index=0&id=f36cc5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36cc5b6"]])

export default __exports__